module.exports = __webpack_public_path__ + "img/air-8.ba295780.jpeg";